/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_HomepageInputs */

const en_nav_app_homepage = /** @type {(inputs: Nav_App_HomepageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Homepage`)
};

const es_nav_app_homepage = /** @type {(inputs: Nav_App_HomepageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página principal`)
};

/**
* | output |
* | --- |
* | "Homepage" |
*
* @param {Nav_App_HomepageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_homepage = /** @type {((inputs?: Nav_App_HomepageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_HomepageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_homepage(inputs)
	return en_nav_app_homepage(inputs)
});